module.exports = __webpack_public_path__ + "img/BannerNewMobileFinish.10aaef84.png";